import React, { useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addEmployeeAppreciation,
  deleteEmployeeAppreciations,
  employeeAppreciation,
} from "../Service/profileService";
import { TostMsg } from "../../../../App";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";

function KudosAndApreciation({ UserId, employeeId }) {
  const [showAppreciationModal, setShowAppreciationModal] = useState({
    type: "",
  });
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [activeTab, setActiveTab] = useState(0);
  const [kudosTab, setKudosTab] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [showContent, setSeleteContent] = useState([]);
  const toster = useContext(TostMsg);
  const [deleteAppreciations, setDeleteAppreciations] = useState(null);
  const [appreciationEditId, setAppreciationEditId] = useState(0);
  const [giveEmployeeAppreciationList, setGiveEmployeeAppreciationList] =
    useState();
  const [giveEmployeeKudosList, setGiveEmployeeKudosList] = useState([]);
  const [isKudosActive, setIsKudosActive] = useState(0);
  useEffect(() => {
    if (employeeId) {
      getEmployeeAppreciation(0);
      getEmployeeKudos(0);
    }
  }, [employeeId]);

  async function getEmployeeKudos(type) {
    setGiveEmployeeKudosList([]);
    let IsGivenValue;
    if (type == 0) {
      IsGivenValue = 0;
      setKudosTab(0);
    } else {
      IsGivenValue = 1;
      setKudosTab(1);
    }
    const params = {
      OrgId: userDetails.OrgId,
      appreciationId: 0,
      EmpId: employeeId,
      IsGiven: IsGivenValue,
    };
    try {
      const response = await employeeAppreciation(params);
      let employeeKudosDatalist = response?.Data;
      let KudosData = employeeKudosDatalist.filter(
        (kudos) => kudos.AppreciationTypeId === 101
      );

      if (type === 0) {
        setGiveEmployeeKudosList(KudosData);
      } else if (type === 1) {
        setGiveEmployeeKudosList(KudosData);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function getEmployeeAppreciation(type) {
    setGiveEmployeeAppreciationList([]);
    let IsGivenValue;
    if (type == 0) {
      IsGivenValue = 0;
      setActiveTab(0);
    } else {
      IsGivenValue = 1;
      setActiveTab(1);
    }
    const params = {
      OrgId: userDetails.OrgId,
      appreciationId: 0,
      EmpId: employeeId,
      IsGiven: IsGivenValue,
    };
    try {
      const response = await employeeAppreciation(params);
      let employeeAppreciationDatalist = response?.Data;
      let AppreciationData = employeeAppreciationDatalist.filter(
        (appreciation) => appreciation.AppreciationTypeId === 102
      );
      if (activeTab === 0) {
        setGiveEmployeeAppreciationList(AppreciationData);
      } else if (activeTab === 1) {
        setGiveEmployeeAppreciationList(AppreciationData);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const handleCloseAppreciationModal = () => {
    document.querySelector("#appre .btn-close")?.click();
    setAppreciationEditId(0);
    appreciationForm.resetForm();
  };

  const AppreciationValidation = Yup.object().shape({
    appreciation: Yup.string().required(
      `${
        showAppreciationModal.type == "appreciation"
          ? "Reason is required."
          : "Reason is required."
      }`
    ),
  });

  const appreciationForm = useFormik({
    initialValues: {
      appreciation: "",
      media: "",
      apreciatedById: "",
    },
    validationSchema: AppreciationValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let appreciationTypeId;
      if (showAppreciationModal.type == "appreciation") {
        appreciationTypeId = 102;
      } else if (showAppreciationModal.type == "kudos") {
        appreciationTypeId = 101;
      }
      const body = {
        OrgId: userDetails.OrgId,
        EmpId: employeeId,
        Id: data?.Id ?? 0,
        ApreciatedById: userDetails.EmpId,
        Appreciation: data?.appreciation,
        Media: data?.media,
        AppreciationTypeId: appreciationTypeId,
      };
      let educationList = await addEmployeeAppreciation(body);
      try {
        if (showAppreciationModal.type == "appreciation" && data?.Id) {
          getEmployeeAppreciation(0);
          GetMasterSystemAlertList("Appreciation_Updated", 0);
        } else if (showAppreciationModal.type == "appreciation" && !data?.Id) {
          getEmployeeAppreciation(0);
          GetMasterSystemAlertList("Appreciation__Added", 0);
        }
        if (showAppreciationModal.type == "kudos" && data?.Id) {
          getEmployeeKudos(0);
          GetMasterSystemAlertList("Update_Kudos", 0);
          setIsloading(false);
        } else if (showAppreciationModal.type == "kudos" && !data?.Id) {
          getEmployeeKudos(0);
          GetMasterSystemAlertList("Kudos_Added", 0);
          setIsloading(false);
        }
        document.querySelector("#appre .btn-close")?.click();
        handleCloseAppreciationModal();
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      } finally {
        setIsloading(false);
      }
    },
  });

  async function editAppreciation(appreciationDetails) {
    if (appreciationDetails) {
      setAppreciationEditId(appreciationDetails?.id);
      // setShowSkillModal(true);
      const editAppreciationData = {
        Id: appreciationDetails?.id,
        apreciatedById: appreciationDetails?.ApreciatedById,
        appreciation: appreciationDetails?.Appreciation,
        media: appreciationDetails?.Media,
        appreciationTypeId: appreciationDetails?.ApreciatedById,
      };
      appreciationForm.setValues(editAppreciationData);
    }
  }

  async function deleteAcademicDetails(event) {
    if (deleteAppreciations?.type == "Appreciations") {
      let body = {
        Id: deleteAppreciations?.appreciation,
        ModifiedBy: userDetails.EmpId,
      };
      setIsloading(true);
      try {
        let appreciationList = await deleteEmployeeAppreciations(body);
        if (appreciationList) {
          GetMasterSystemAlertList("Appreciation_Deleted", 0);
          if (userDetails?.EmpId != employeeId) {
            getEmployeeAppreciation(0);
          } else {
            getEmployeeAppreciation(1);
          }

          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
    if (deleteAppreciations?.type == "kudos") {
      let body = {
        Id: deleteAppreciations?.appreciation,
        ModifiedBy: userDetails.EmpId,
      };
      setIsloading(true);
      try {
        let kudosList = await deleteEmployeeAppreciations(body);
        if (kudosList) {
          GetMasterSystemAlertList("Remove_Kudos", 0);
          if (userDetails?.EmpId != employeeId) {
            getEmployeeKudos(0);
          } else {
            getEmployeeKudos(1);
          }
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const addApprecation = () => {
    setAppreciationEditId(0);
    appreciationForm.resetForm();
  };

  return (
    <div>
      <div className="profile-about-me position-relation">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0">
            <h4 className="text-primary mb-3 sumh4 addprofile-action">
              Kudos
              {userDetails?.EmpId != employeeId && (
                <>
                  {/* {isKudosActive == 1 && ( )} */}
                  <span>
                    <a
                      className="edit-btncss mb-2 love-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#appre"
                      title="Add Kudos"
                      aria-label="Kudos"
                      onClick={() => {
                        setShowAppreciationModal({
                          type: "kudos",
                        });
                        addApprecation();
                        GetMasterSystemAlertList("Add_Kudos", 1);
                      }}
                    >
                      <img
                        src="/images/org-img/profile/add.png"
                        className="w-100"
                      />
                    </a>
                  </span>
                </>
              )}
            </h4>
            <ul className="g-rul">
              {userDetails?.EmpId == employeeId && (
                <>
                  <li
                    className={kudosTab === 0 ? "active" : ""}
                    onClick={() => getEmployeeKudos(0)}
                  >
                    Received
                  </li>
                  <li
                    className={kudosTab === 1 ? "active" : ""}
                    onClick={() => getEmployeeKudos(1)}
                  >
                    Given
                  </li>
                </>
              )}
            </ul>
            <div className="kudos-wrapper">
              {giveEmployeeKudosList?.map((kudos, index) => (
                <div key={index} className="kudos-item on-hover-icon">
                  <div className="kudos-listdiv">
                    <div className="h-avatar is-large">
                      <LazyImage
                        className="avatar"
                        src={
                          kudosTab == 0
                            ? kudos?.AppreciationByProfileImage
                            : kudos?.EmployeeProfileImage
                        }
                      />
                    </div>
                    <div className="meta">
                      <h4>
                        {kudosTab == 0
                          ? kudos?.AppreciationByName
                          : kudos?.EmployeeName}
                      </h4>
                      <p>{kudos?.Designation}</p>

                      <span>
                        {kudos?.CreatedDate ? (
                          <>
                            {moment(kudos?.CreatedDate).format("MMM DD YYYY")}
                          </>
                        ) : (
                          "N/A"
                        )}
                      </span>
                      <p className="appre-p">{kudos?.Appreciation}</p>
                    </div>
                  </div>
                  <div className="hover-badges-box">
                    {userDetails?.EmpId == kudos?.ApreciatedById && (
                      <button
                        onClick={() => {
                          setDeleteAppreciations({
                            appreciation: kudos?.id,
                            type: "kudos",
                          });
                          GetMasterSystemAlertList("Delete_Kudos", 1);
                        }}
                        className="skill-actionbtn"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-edkA"
                      >
                        <img src="/images/org-img/delete.png" />
                      </button>
                    )}
                    {userDetails?.EmpId == kudos?.ApreciatedById && (
                      <button
                        className="skill-actionbtn"
                        data-bs-toggle="modal"
                        data-bs-target="#appre"
                        title="Edit"
                        aria-label="Kudos"
                        onClick={() => {
                          GetMasterSystemAlertList("edit_Kudos", 1);
                          editAppreciation(kudos);
                          setShowAppreciationModal({
                            type: "kudos",
                          });
                        }}
                      >
                        <img src="/images/org-img/edit.png" />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="pt-2 border-bottom-1 position-relation">
        <div className="">
          <h4 className="text-primary mb-3 sumh4 addprofile-action">
            Appreciation
            {userDetails?.EmpId != employeeId && (
              <span>
                <a
                  className="edit-btncss mb-2 love-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#appre"
                  title="Add Appreciation"
                  data-bs-original-title="Appreciate"
                  aria-label="Appreciate"
                  onClick={() => {
                    setShowAppreciationModal({
                      type: "appreciation",
                    });
                    addApprecation();
                    GetMasterSystemAlertList("Add_Appreciation", 1);
                  }}
                >
                  <img
                    src="/images/org-img/profile/add.png"
                    className="w-100"
                  />
                </a>
              </span>
            )}
          </h4>
          <ul className="g-rul">
            {userDetails?.EmpId == employeeId && (
              <>
                <li
                  className={activeTab === 0 ? "active" : ""}
                  onClick={() => getEmployeeAppreciation(0)}
                >
                  Received
                </li>

                <li
                  className={activeTab === 1 ? "active" : ""}
                  onClick={() => getEmployeeAppreciation(1)}
                >
                  Given
                </li>
              </>
            )}
          </ul>
          <div className="kudos-wrapper">
            {giveEmployeeAppreciationList?.map((Appreciation, index) => (
              <div key={index} className="kudos-item on-hover-icon">
                <div className="kudos-listdiv">
                  <div className="h-avatar is-large">
                    <LazyImage
                      className="avatar"
                      src={
                        activeTab == 0
                          ? Appreciation?.AppreciationByProfileImage
                          : Appreciation?.EmployeeProfileImage
                      }
                    />
                  </div>
                  <div className="meta">
                    <h4>
                      {activeTab == 0
                        ? Appreciation?.AppreciationByName
                        : Appreciation?.EmployeeName}
                    </h4>
                    <p>{Appreciation?.Designation}</p>

                    <span>
                      {Appreciation?.CreatedDate ? (
                        <>
                          {moment(Appreciation?.CreatedDate).format(
                            "MMM DD YYYY"
                          )}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </span>
                    <p className="appre-p">{Appreciation?.Appreciation}</p>
                  </div>
                </div>
                <div className="hover-badges-box">
                  {userDetails?.EmpId == Appreciation?.ApreciatedById && (
                    <button
                      style={{
                        marginLeft: "2px",
                        float: "right",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setDeleteAppreciations({
                          appreciation: Appreciation?.id,
                          type: "Appreciations",
                        });
                        GetMasterSystemAlertList("Delete_Appreciation", 1);
                      }}
                      className="skill-actionbtn"
                      title="Delete"
                      data-bs-toggle="modal"
                      data-bs-target="#delete-edkA"
                    >
                      <img src="/images/org-img/delete.png" />
                    </button>
                  )}
                  {userDetails?.EmpId == Appreciation?.ApreciatedById && (
                    <button
                      style={{
                        float: "right",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        editAppreciation(Appreciation);
                        GetMasterSystemAlertList("Edit_Appreciation", 1);
                        setShowAppreciationModal({
                          type: "appreciation",
                        });
                      }}
                      className="skill-actionbtn"
                      title="Edit"
                      data-bs-toggle="modal"
                      data-bs-target="#appre"
                    >
                      <img src="/images/org-img/edit.png" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="modal fade custom-modal-area"
        tabIndex="-1"
        aria-hidden="true"
        id="appre"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "450px" }}
        >
          <div className="modal-content add-editeducation add-editexperience">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>

              <button
                onClick={handleCloseAppreciationModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body ">
              <div className="text-center">
                  <strong className="modal-title">
                {appreciationEditId != 0 ? (
                  <h5 className="modal-title m-auto">
                    Edit {showAppreciationModal.type}
                  </h5>
                ) : (
                  <h5 className="modal-title m-auto">
                    Add {showAppreciationModal.type}
                  </h5>
                )}
              </strong>
              <p>{showContent}</p>
              </div>
              <div className="addcourseform">
                <form onSubmit={appreciationForm.handleSubmit}>
                  <div className="row">
                    <div className="mb-4 col-md-12 ">
                      <div className="position-relative">
                      <label className="form-label">
                        Reason<i className="inValidError">*</i>
                      </label>
                      <textarea
                        type="text"
                        rows={"5"}
                        cols={"1"}
                        name="appreciation"
                        maxLength={500}
                        className={
                          "form-control h-auto" +
                          (appreciationForm.errors.appreciation &&
                          appreciationForm.touched.appreciation
                            ? " is-invalid"
                            : "")
                        }
                        onChange={appreciationForm.handleChange}
                        value={appreciationForm.values.appreciation}
                        // placeholder={`Enter a ${showAppreciationModal.type}`}
                        placeholder="Enter a reason"
                      />
                      <div
                        style={{
                          textAlign: "right",
                          fontSize: "12px",
                          position: "absolute",
                          right: "27px",
                          bottom: "2px",
                          color:
                            appreciationForm.values.appreciation.length === 500
                              ? "red"
                              : "#555",
                        }}
                      >
                        {appreciationForm.values.appreciation.length}/{500}
                      </div>
                      </div>
                      <div className="invalid-feedback">
                        {appreciationForm.errors.appreciation &&
                        appreciationForm.touched.appreciation
                          ? appreciationForm.errors.appreciation
                          : null}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handleCloseAppreciationModal}
                    >
                      Cancel
                    </button>
                    {appreciationEditId != 0 ? (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="delete-edkA">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAcademicDetails("delete")}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default KudosAndApreciation;
